import peopleDeskLogo from './logo1.png';
import bendaLogo from './benda infotech update logo png.png';

/** Canonical People Desk HRMS logo (all shell, auth, payslip, favicon). Same asset in every theme. */
export const PEOPLE_DESK_LOGO = peopleDeskLogo;
export const PEOPLE_DESK_LOGO_ALT = 'People Desk';

export const BENDA_LOGO = bendaLogo;
export const BENDA_LOGO_ALT = 'Benda Infotech LLP';
